import { useEffect, useState } from "react";
import { Button, Container, Row, Col, Table, ProgressBar } from "react-bootstrap";
import { BiMessageSquareEdit } from "react-icons/bi";
import { useParams } from "react-router-dom";

import {
  IoDocumentSharp,
  IoListCircleSharp,
  IoNewspaperOutline,
  IoLocationSharp,
} from "react-icons/io5";
import { GrDocumentText } from "react-icons/gr";

import history from "../../../history";
import { ProjectDataType, AddressType, MeterActivityStatusProps } from "../../ts/types";
import { getFarmerById, getMeterActivityStatus } from "../../../helpers/api";
import { formatTimeDuration, getCurrentGmtTime } from "../../../helpers/dateTime";

//Shared
import { LoadingOverlay } from "../../components/shared";

//Components
import GeneralInfo from "./components/GeneralInfo";
import FilesAndLog from "./components/FilesAndLog";
import MessageLogs from "./components/MessageLogs";
import { useUserInfoContext } from "../../context/UserInfoContext";

const Installation = () => {
  const { projectId } = useParams() as any;
  const [meterDetails, setmeterDetails] = useState({} as MeterActivityStatusProps);
  const [loading, setLoading] = useState(true);
  const [userInfo, setUserInfo] = useState(false as unknown as ProjectDataType);

  const { user }: any = useUserInfoContext();

  useEffect(() => {
    getMeterActivityStatus(projectId)
      .then((res) => {
        setmeterDetails(res.data);
      })
      .finally(() => setLoading(false));
  }, [projectId]);

  useEffect(() => {
    getFarmerById(projectId)
      .then((res: any) => {
        setUserInfo(res.data);
      })
      .finally(() => setLoading(false));
  }, [projectId]);

  const handleCreateEditMeter = () => {
    if (meterDetails.projectMeter) {
      history.push(`/edit-meter/${projectId}`);
    } else {
      history.push(`/create-meter/${projectId}`);
    }
  };

  return (
    <div>
      {loading && <LoadingOverlay />}
      <GeneralInfo />

      <p
        style={{
          fontSize: "0.9rem",
          fontWeight: "bold",
          color: "silver",
        }}
      >
        Project Status
      </p>
      <Row style={{ width: "50%" }}>
        <Col md={10}>
          <p
            style={{
              fontSize: "0.9rem",
              fontWeight: "bold",
            }}
          >
            Installation
          </p>
        </Col>
        <Col>
          <p
            style={{
              fontSize: "0.9rem",
              color: "silver",
            }}
          >
            3/4
          </p>
        </Col>
      </Row>
      <Row style={{ width: "50%", marginBottom: "15px" }}>
        <Col>
          <ProgressBar style={{ height: "10px" }} now={100} />
        </Col>
        <Col>
          <ProgressBar style={{ height: "10px" }} now={100} />
        </Col>
        <Col>
          <ProgressBar style={{ height: "10px" }} now={100} />
        </Col>
        <Col>
          <ProgressBar style={{ height: "10px" }} now={0} />
        </Col>
      </Row>
      <p
        style={{
          fontSize: "0.8rem",
        }}
      >
        The work order has been issued. The company has been given the approval to install the
        <br /> project. The Meter has been dispatched. Awaiting Project Details.
      </p>
      <hr
        style={{
          backgroundColor: "silver",
          border: "1px silver solid",
          margin: "2rem 0",
        }}
      />
      <p
        style={{
          fontSize: "0.9rem",
          fontWeight: "bold",
          color: "silver",
        }}
        id="Equipments"
      >
        Equipment
      </p>
      <Container
        fluid
        style={{
          border: "1.5px solid silver",
          borderRadius: "10px",

          fontWeight: "normal",
        }}
      >
        <Row
          style={{
            borderRadius: "10px",
            backgroundColor: "rgb(230, 230, 230)",
            paddingTop: "15px",
            paddingBottom: "15px",
          }}
        >
          <Col md={7} xs={6} className="pt-2">
            <p>
              <b>Project Details</b>
            </p>
          </Col>
          <Col md={5} xs={6}>
            <div className="d-flex justify-content-end">
              {/* <Row>
              <Col
                xl={8}
                lg={12}
                md={12}
                sm={12}
                xs={12}
                className="installation_editDetails p-xl-0"
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              > */}
              {user?.role === "SUPERADMIN" && (
                <Button
                  variant="outline-primary"
                  style={{ fontSize: "0.8rem", backgroundColor: "white", marginRight: "5px" }}
                  onClick={() => history.push(`/edit-project/${projectId}/general-information`)}
                >
                  <BiMessageSquareEdit size={20} style={{ color: "#4173BD" }} /> {""}
                  <b style={{ color: "#4173BD" }}>Edit Project Details</b>
                </Button>
              )}
              {/* </Col>

              <Col
                xl={4}
                lg={12}
                md={12}
                sm={12}
                xs={12}
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginLeft: "-12px",
                }}
              > */}
              {/* <span style={{ backgroundColor: "white", marginLeft: "10px" }}> */}
              <Button
                variant="primary"
                style={{ fontSize: "0.8rem", marginRight: "5px" }}
                onClick={() => history.push(`/project-status/${projectId}/projectDetails`)}
              >
                <b> View Details</b>
              </Button>
            </div>
            {/* </span>
              </Col>
            </Row> */}
          </Col>
        </Row>
        <Table responsive>
          <thead className="farmerDetail__thead">
            <tr
              style={{
                borderBottom: "1.5px solid silver",
                fontWeight: "normal",
                textAlign: "center",
              }}
            >
              <th>Total Head</th>
              <th>Maximum Daily Discharge</th>
              <th>Solar Array</th>
              <th>Total Solar Capacity</th>
              <th>Pump Summary</th>
              <th>Controller Capacity</th>
            </tr>
          </thead>
          <tbody>
            <tr
              style={{
                borderBottom: "1.5px solid white",
                fontWeight: "normal",
                textAlign: "center",
              }}
            >
              <td>{(userInfo && userInfo.waterSourceDetails.head) || "N/A"}</td>
              <td>{(userInfo && userInfo.waterSourceDetails.discharge) || "N/A"}</td>
              <td>{(userInfo && userInfo.solarArrayDetails.type) || "N/A"}</td>
              <td>{(userInfo && userInfo.solarArrayDetails.totalCapacity) || "N/A"}</td>
              <td>N/A</td>
              <td>
                {(userInfo && userInfo.controllerDetails.controllerCapacity) || "N/A"}
                {userInfo && userInfo.controllerDetails.controllerCapacityUnit}
              </td>
            </tr>
          </tbody>
        </Table>
      </Container>
      <Container
        fluid
        className="mt-5"
        style={{
          border: "1.5px solid silver",
          borderRadius: "10px",

          fontWeight: "normal",
        }}
      >
        <Row
          style={{
            borderRadius: "10px",
            backgroundColor: "rgb(230, 230, 230)",
            paddingTop: "15px",
            paddingBottom: "15px",
          }}
        >
          <Col md={7} xs={6} className="pt-2">
            <p>
              <b>Meter Details</b>
            </p>
          </Col>
          <Col md={5} xs={6}>
            <div className="d-flex justify-content-end">
              {/* <Row>
              <Col
                xl={8}
                lg={12}
                md={12}
                sm={12}
                xs={12}
                className="installation_editDetails p-xl-0"
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              > */}
              {user?.role === "SUPERADMIN" && (
                <>
                  {meterDetails.projectMeter && (
                    <Button
                      variant="outline-primary"
                      style={{ fontSize: "0.8rem", backgroundColor: "white", marginRight: "5px" }}
                      onClick={() => history.push(`/configure-meter/${projectId}`)}
                    >
                      <BiMessageSquareEdit
                        size={20}
                        style={{ marginRight: "8px", color: "#4173BD" }}
                      />
                      <b style={{ color: "#4173BD" }}>Configure Meter</b>
                    </Button>
                  )}
                  <Button
                    variant="outline-primary"
                    style={{ fontSize: "0.8rem", backgroundColor: "white", marginRight: "5px" }}
                    onClick={handleCreateEditMeter}
                  >
                    <BiMessageSquareEdit
                      size={20}
                      style={{ marginRight: "8px", color: "#4173BD" }}
                    />
                    <b style={{ color: "#4173BD" }}>
                      {!meterDetails.projectMeter ? "Create Meter" : "Edit Meter"}
                    </b>
                  </Button>
                </>
              )}
              {/* </Col>

              <Col
                xl={4}
                lg={12}
                md={12}
                sm={12}
                xs={12}
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginLeft: "-12px",
                }}
              > */}
              {/* <span style={{ backgroundColor: "white" }}> */}
              <Button
                variant="primary"
                style={{ fontSize: "0.8rem", marginRight: "5px" }}
                onClick={() => history.push(`/meter-details/${projectId}`)}
              >
                <b> View Meter</b>
              </Button>
              {/* </span> */}
              {/* </Col>
            </Row> */}
            </div>
          </Col>
        </Row>
        <Table responsive>
          <thead className="farmerDetail__thead">
            <tr
              style={{
                borderBottom: "1.5px solid silver",
                fontWeight: "normal",
              }}
            >
              <th>Meter Number</th>

              <th>Meter ID</th>

              <th>Meter Status</th>

              <th>Last Active</th>
            </tr>
          </thead>
          <tbody>
            <tr
              style={{
                borderBottom: "1.5px solid white",
                fontWeight: "normal",
              }}
            >
              <td>{meterDetails.projectMeter?.phoneNumber || "N/A"}</td>
              <td>{meterDetails.projectMeter?.hardwareId || "N/A"}</td>
              <td>{meterDetails.projectMeter?.status === "Y" ? "Active" : "Inactive"}</td>
              <td>
                {formatTimeDuration(
                  getCurrentGmtTime() -
                    new Date(meterDetails.projectMeter?.meterData[0]?.receivedAt).getTime()
                ) || "N/A"}
              </td>
            </tr>
          </tbody>
        </Table>
      </Container>

      <MessageLogs projectIdNumber={projectId} />
      <FilesAndLog />
    </div>
  );
};

export default Installation;
